// @flow
import React from 'react'
import { ReactionCount } from '../reactioncount'
import './styles.scss'

export class StoryTeaser extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {}
    this.reactionRef = React.createRef()

    this.updateReactionCount = this.updateReactionCount.bind(this)
  }

  updateReactionCount() {
    // console.log('updateReactionCount')
    this.reactionRef.current.getVotes()
  }

  componentDidMount() {}

  render() {
    return (
      <div className='column'>
        <div
          className='teaser'
          onClick={() =>
            this.props.openStory(
              this.props.index,
              this.props.teaserIndex,
              this.props.title
            )
          }
        >
          <div className='illustration'>
            <img className='ui fluid image' src={this.props.image} />
          </div>
          <h4>{this.props.person}</h4>
          <h3>{this.props.title}</h3>
          <div className='short'>
            {this.props.children}
            <div className='foot'>
              <div className='more'>mehr lesen</div>
              <ReactionCount
                storyID={this.props.id}
                articleID={this.props.articleID}
                ref={this.reactionRef}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}
